import { render } from "./AdminPagesHome.vue?vue&type=template&id=10c270be"
import script from "./AdminPagesHome.vue?vue&type=script&lang=js"
export * from "./AdminPagesHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__